import { render, staticRenderFns } from "./bindAcctDc.vue?vue&type=template&id=0dbb9502&scoped=true"
import script from "./bindAcctDc.vue?vue&type=script&lang=js"
export * from "./bindAcctDc.vue?vue&type=script&lang=js"
import style0 from "./bindAcctDc.vue?vue&type=style&index=0&id=0dbb9502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbb9502",
  null
  
)

export default component.exports